import { render, staticRenderFns } from "./SocialInteractions.vue?vue&type=template&id=f3303f82&scoped=true&"
import script from "./SocialInteractions.vue?vue&type=script&lang=ts&"
export * from "./SocialInteractions.vue?vue&type=script&lang=ts&"
import style0 from "./SocialInteractions.vue?vue&type=style&index=0&id=f3303f82&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3303f82",
  null
  
)

export default component.exports